import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import axios from 'axios';
import { ApiUrl } from '../../../services/ApiRest';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const ListPassenger = () => {
    const [passenger, setpassenger] = useState([]);
    const [listTour, setlistTour] = useState([]);
    const [selectedPassenger, setselectedPassenger] = useState([]);



    const getData = async () => {
        await axios.get(ApiUrl + "passengers-show")
            .then(response => {
                const data = response.data;
                setpassenger(data);

                //cargamos los datos nuevos
                const script = document.createElement("script");
                script.src = `/assets/dataTable/dataTable.js`;
                script.async = true;
                document.body.appendChild(script);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const deleteTable = () => {
        const script1 = document.createElement("script");
        script1.src = `/assets/dataTable/datatable-destroy.js`;
        script1.async = true;
        document.body.appendChild(script1);
    }

    const selectpax = (data) => {
        setselectedPassenger(data);
    }

    const showtours = async (data) => {
        setselectedPassenger(data);
        await axios.get(ApiUrl + "passengers-show-tours/"+data.ci)
            .then(response => {
                const dataTour = response.data;
                setlistTour(dataTour);

                //cargamos los datos nuevos
                const script = document.createElement("script");
                script.src = `/assets/dataTable/dataTable.js`;
                script.async = true;
                document.body.appendChild(script);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const deletepax = async () => {
        await axios.post(ApiUrl + 'catalogue-pax-delete/' + selectedPassenger.pax_catalogues_id)
            .then(resp => {
                deleteTable();
                getData();
                toast.success("pax Eliminado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });

            })
            .catch(e => {
                console.log(e);
            })
    }



    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <div className='row'>
                <div className='col-12 '>
                    <div className="card">
                        <div className="card-header">
                            LISTA DE CLIENTES
                        </div>
                        <div className="card-body table-responsive">
                            <table className='table table-hover' id="dataTable" style={{ width: '100%' }} >
                                <thead>
                                    <tr>
                                        {/* <th>#</th> */}
                                        <th>CI</th>
                                        <th>Nombre</th>
                                        <th>Teléfono</th>
                                        <th>Ciudad</th>
                                        <th>Correo</th>
                                        <th>Edad</th>
                                        <th># Rutas</th>
                                        <th>Rutas realizadas</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {passenger.map((pax, index) => (
                                        <tr key={pax.passenger_id}>
                                            {/* <td>{index + 1}</td> */}
                                            <td>{pax.ci}</td>
                                            <td>{pax.name}</td>
                                            <td>{pax.phone}</td>
                                            <td>{pax.city}</td>
                                            <td>{pax.correo}</td>
                                            <td>{pax.age}</td>
                                            <td>{pax.count}</td>
                                            <td><label style={{ fontSize: "0.7rem" }}>{pax.tour_destinations}</label></td>
                                            <td>
                                                <button className='btn btn-outline-primary btn-sm' data-bs-toggle="modal" data-bs-target="#showRutes" onClick={() => showtours(pax)}><i className="fas fa-shuttle-van"></i></button>
                                                {/* <Link to={"../edit-catalogue/" + pax.pax_catalogues_id}>
                              <button className='btn btn-outline-primary  btn-sm' ><ModeEditOutlineOutlinedIcon/></button>
                            </Link>
                            <button className='btn btn-outline-danger btn-sm' data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => selectpax(pax)}><DeleteOutlinedIcon/></button> */}

                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="showRutes" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Rutas realizadas</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                Rutas Realizadas por <b>{selectedPassenger.name}</b>
                                <table className='table table-hover' id="dataTable" style={{ width: '100%' }} >
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Ruta</th>
                                            <th>Fecha</th>
                                           
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listTour.map((pax, index) => (
                                            <tr key={pax.passenger_id}>
                                                <td>{index + 1}</td>
                                                <td>{pax.tour_destiny}</td>
                                                <td>{pax.departure_date}</td>
                                                

                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"  >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Eliminar</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                Está seguro que desea eliminar <b>{selectedPassenger.pax_destiny}</b>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => deletepax()} data-bs-dismiss="modal" >Aceptar</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal"  >Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer theme="colored" />

        </div>
    )
}

export default ListPassenger
